<template>
	<view :style="{height,width}">
		<view class="fixed-center">
			<fui-load-ani type="5"></fui-load-ani>
			<view class="fui-flex__center text mt10">加载中</view>
		</view>
	</view>
</template>

<script>
	export default {
		name: "xc-h5-async-loading",
		props: {
			width: {
				type: String,
				default: ''
			},
			height: {
				type: String,
				default: '50vh'
			}
		},
		data() {
			return {
				isFixed: true
			};
		}
	}
</script>
<style scoped lang="less">
	.text {
		font-size: 22rpx;
		color: var(--fui-color-primary, #465CFF);
	}
</style>